module.exports = __webpack_public_path__ + "img/1.fb1614c3.jpeg";